/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { FileSharesPublicClouds } from './components';

export const BackupJobsFileSharesPublicCloudsPage: React.FC<{}> = () => (
    <TabBarBodyLayout>
        <FileSharesPublicClouds />
    </TabBarBodyLayout>
);
